module.exports = "/_next/static/images/AccessibleAiImage@2x-59c941ab14b20cf081d936eb60fd6500.png";